import React from 'react';
import { Link } from 'react-router-dom';

import { useEffect } from 'react';

import MeetupsThumb01 from '../../images/meetups-thumb-01.jpg';
import UserImage01 from '../../images/avatar-01.jpg';

function NewsItemContext({id, imageURL, published, title, textContent, link}) {

  return (

    <article key={id} className="flex bg-white w-full shadow-1 rounded-sm border border-slate-200 overflow-hidden max-h-24 mb-2">

      {/* Image */}
      <a className="flex-none w-20 cursor-pointer" href={link} target="_blank">
        <img className="object-cover object-center w-full h-full"
          src={imageURL}
          alt="NewsItem" />
      </a>
      {/* Content */}
      <a className="flex h-20 w-full px-2" href={link} target="_blank">
        <div>
          <div className="text-sm font-semibold text-pink-500">{new Date(published).toLocaleString()}</div>
          <div className="inline-flex cursor-pointer">
            <h3 className="text-sm font-bold text-slate-800 line-clamp-1">{title}</h3>
          </div>
          <div className="text-sm line-clamp-1">{textContent}</div>
        </div>
        {/* Footer */}
        <div className="flex justify-between mt-3">
          {/* Tag */}
          <div className="text-xs inline-flex items-center font-medium bg-slate-100 text-slate-600 rounded-full text-center px-2.5 py-1">
            {/*<div className="text-xs inline-flex font-medium bg-indigo-100 text-indigo-600 rounded-full text-center px-2.5 py-1">notifications</div>*/}
          </div>
          {/* Likes */}
          {/*<div className="flex items-center">
            <div className="text-slate-100 bg-slate-900 bg-opacity-60 rounded-full cursor-pointer" onClick={()=>cardLiked(id, likes)}>
              <span className="sr-only">Like</span>
              <svg className="h-8 w-8 fill-current" viewBox="0 0 32 32">
                <path d="M22.682 11.318A4.485 4.485 0 0019.5 10a4.377 4.377 0 00-3.5 1.707A4.383 4.383 0 0012.5 10a4.5 4.5 0 00-3.182 7.682L16 24l6.682-6.318a4.5 4.5 0 000-6.364zm-1.4 4.933L16 21.247l-5.285-5A2.5 2.5 0 0112.5 12c1.437 0 2.312.681 3.5 2.625C17.187 12.681 18.062 12 19.5 12a2.5 2.5 0 011.785 4.251h-.003z" />
              </svg>
            </div>
            <div className="text-xs font-medium text-slate-400 italic">{likes}</div>
          </div>*/}
        </div>
      </a>
    </article>
  );
}

export default NewsItemContext;